import MENTORSHIP_STATUS, {
  MentorshipStatusValues,
  MENTORSHIP_MENTEE_STATUS,
  MENTORSHIP_MENTOR_STATUS,
} from 'enums/MentorshipStatus';
import { FC } from 'react';
import Chip from '../Chip';

type Props = {
  status: MentorshipStatusValues;
  variant?: 'default' | 'mentee' | 'mentor';
};

const MentorshipStatusChip: FC<Props> = ({ status, variant }) => {
  const text =
    variant === 'mentee'
      ? MENTORSHIP_MENTEE_STATUS[status]
      : variant === 'mentor'
      ? MENTORSHIP_MENTOR_STATUS[status]
      : MENTORSHIP_STATUS[status];
  switch (status) {
    case 'MENTOR_ACCEPTING':
    case 'WAITING_MENTOR':
    case 'WAITING_MENTEE':
      return (
        <Chip bgColor="#F4F3FF" color="#5925DC">
          {text}
        </Chip>
      );
    case 'REFUSED_MENTOR':
    case 'REFUSED_MENTEE':
      return (
        <Chip bgColor="#FEF3F2" color="#B42318">
          {text}
        </Chip>
      );
    case 'ONGOING':
      return (
        <Chip bgColor="#F0F9FF" color="#026AA2">
          {text}
        </Chip>
      );
    case 'LATE_MENTEE_FIRST_INTERVIEW':
    case 'LATE_MENTOR_FIRST_INTERVIEW':
    case 'LATE_MENTOR':
    case 'LATE_MENTEE':
      return (
        <Chip bgColor="#FFF6ED" color="#C4320A">
          {text}
        </Chip>
      );
    case 'INTERRUPTION_REQUEST_MENTEE':
      if (variant === 'mentor') {
        return (
          <Chip bgColor="#F0F9FF" color="#026AA2">
            {text}
          </Chip>
        );
      }
      return (
        <Chip bgColor="#FDF2FA" color="#C11574">
          {text}
        </Chip>
      );
    case 'INTERRUPTION_REQUEST_MENTOR':
      if (variant === 'mentee') {
        return (
          <Chip bgColor="#F0F9FF" color="#026AA2">
            {text}
          </Chip>
        );
      }
      return (
        <Chip bgColor="#FDF2FA" color="#C11574">
          {text}
        </Chip>
      );
    case 'INTERRUPTED_ADMIN':
      return (
        <Chip bgColor="#FDF2FA" color="#C11574">
          {text}
        </Chip>
      );
    case 'FINISHED_ADMIN':
    case 'FINISHED_DATE':
    case 'FIRST_INTERVIEW':
      return (
        <Chip bgColor="#ECFDF3" color="#027A48">
          {text}
        </Chip>
      );
    default:
      return null;
  }
};

export default MentorshipStatusChip;
